const text = {
    en: {
        packages: [
            {label: "amsterdam", airport_code: "amsterdam-package", value: 1},
            {label: "berlin", airport_code: "berlin-package", value: 5},
            {label: "paris", airport_code: "paris-package", value: 12},
            {label: "budapest", airport_code: "budapest-package", value: 2},
            {label: "london", airport_code: "london-package", value: 7},
            {label: "new york", airport_code: "new-york-package", value: 9},
            {label: "bucharest", airport_code: "bucharest-package", value: 3},
            {label: "barcelona", airport_code: "barcelona-package", value: 122},
            {label: "prague", airport_code: "prague-package", value: 157},
            {label: "sofia", airport_code: "sofia-package", value: 153},
        ],
        destinations: [
            {label: "Amsterdam, Netherlands - AMS - Schiphol", airport_code: "AMS", value: 444},
            {label: "Berlin, Germany - BER - Berlin Brandenburg Willy Brandt", airport_code: "BER", value: 21111},
            {label: "Paris, France - PAR - All airports", airport_code: "PAR", value: 5039},
            {label: "Budapest, Hungary - BUD - Ferihegy", airport_code: "BUD", value: 1059},
            {label: "London, United Kingdom - LON - All airports", airport_code: "LON", value: 5040},
            {label: "New York, United States - NYC - All airports", airport_code: "NYC", value: 5041},
            {label: "Madrid, Spain - MAD - Barajas", airport_code: "MAD", value: 898},
            {label: "Rhodos, Greece - RHO - Rhodes Diagoras", airport_code: "RHO", value: 1048},
            {label: "Prague, Czech Republic - PRG - Ruzyne", airport_code: "PRG", value: 1119},
            {label: "Bangkok, Thailand - BKK - Suvarnabhumi Intl", airport_code: "BKK", value: 21105},
            {label: "Bucharest, Romania - OTP - Henri Coanda", airport_code: "BUH", value: 21112},
            {label: "Bourgas, Bulgaria - BOJ - Burgas", airport_code: "BOJ", value: 869},
            {label: "Varna, Bulgaria - VAR - Varna", airport_code: "VAR", value: 873}
        ],
        origins: [
            {label: "Amsterdam, Netherlands - AMS - Schiphol", airport_code: "AMS", value: 444},
            {label: "Berlin, Germany - BER - Berlin Brandenburg Willy Brandt", airport_code: "BER", value: 21111},
            {label: "Paris, France - PAR - All airports", airport_code: "PAR", value: 5039},
            {label: "Budapest, Hungary - BUD - Ferihegy", airport_code: "BUD", value: 1059},
            {label: "London, United Kingdom - LON - All airports", airport_code: "LON", value: 5040},
            {label: "New York, United States - NYC - All airports", airport_code: "NYC", value: 5041},
            {label: "Madrid, Spain - MAD - Barajas", airport_code: "MAD", value: 898},
            {label: "Rhodos, Greece - RHO - Rhodes Diagoras", airport_code: "RHO", value: 1048},
            {label: "Prague, Czech Republic - PRG - Ruzyne", airport_code: "PRG", value: 1119},
            {label: "Bangkok, Thailand - BKK - Suvarnabhumi Intl", airport_code: "BKK", value: 21105},
            {label: "Bucharest, Romania - OTP - Henri Coanda", airport_code: "BUH", value: 21112},
            {label: "Bourgas, Bulgaria - BOJ - Burgas", airport_code: "BOJ", value: 869},
            {label: "Varna, Bulgaria - VAR - Varna", airport_code: "VAR", value: 873}
        ],
        childWithAdultError: "Babies and children must be accompanied by at least one adult",
        babyWithAdultError: "A baby uner the age of 2 years must be accompanied by at least one adult.",
        maxPassengersError: "Up to 9 passengers per resrvation",
        maxThreeChildError: "Can't select more than 3 children in each room",
        destinationsInputPlaceholder: "Please type city or airport name ",
        packagesInputPlaceholder: "Please type city name",
        selectOutboundDate: "Departure date",
        selectInboundDate: "Return date ",
        datesLocale: "en-US",
        destinationsHeader: "Destination",
        originHeader: "Departure",
        passengersSelectHeader: "Travelers",
        roomsSelectHeader: "Select number of guests per room  ",
        save: "Save",
        selectDestinations: "Destinations",
        selectDeparture: "Departure",
        bestDestinations: "Recommended",
        noDestination: "Something has gone missing. Sorry about that.",
        destinationFlightPlaceholder: "Type destination name",
        originFlightPlaceholder: "Type origin name",
        adult: "Adults",
        child: "Children",
        baby: "Babies",
        senior: "Senior",
        roundtrip: "Roundtrip",
        oneway: "One way",
        originTextTLV: "Tel Aviv-TLV -ISRAEL",
        originTextJNB: "Johannesburg - JNB - South Africa",
        landingAt: "Destination",
        outboundDate: "Departure date",
        inboundDate: "Return date",
        passengersCount: "Travelers",
        directFlightsOnly: "Direct flights only",
        searchButtonFlights: "Search flight",
        searchButtonPackages: "Search",
        childSubText: "(Under 12 years)",
        babySubText: "(Under 2 years)",
        seniorSubText: "(Over 65+)",
        headerFlightButton: "FLIGHT",
        headerPackageButton: "FLIGHT+HOTEL",
        room: "Room",
        total: "Total",
        guests: "Guests",
        selectChildAgesTitle: " Select Child Age",
        selectChildAges: "Select Children Age",
        selectChildAge: "Select Child Age",
        addRoom: "+ Add room"
    },
    he: {
        packages: [
            {label: "אמסטרדם", airport_code: "amsterdam-package", value: 1},
            {label: "ברלין", airport_code: "berlin-package", value: 5},
            {label: "פריז", airport_code: "paris-package", value: 12},
            {label: "בודפשט", airport_code: "budapest-package", value: 2},
            {label: "לונדון", airport_code: "london-package", value: 7},
            {label: "ניו יורק", airport_code: "new-york-package", value: 9},
            {label: "בוקרשט", airport_code: "bucharest-package", value: 3},
            {label: "ברצלונה", airport_code: "barcelona-package", value: 122},
            {label: "פראג", airport_code: "prague-package", value: 157},
            {label: "סופיה", airport_code: "sofia-package", value: 153}
        ],
        destinations: [
            {label: "אמסטרדם, הולנד - Amsterdam - Schiphol - AMS", airport_code: "AMS", value: 444},
            {label: "ברלין, גרמניה - Berlin - All airports - BER", airport_code: "BER", value: 21111},
            {label: "פריז, צרפת - Paris - All airports - PAR", airport_code: "PAR", value: 5039},
            {label: "בודפשט, הונגריה - Budapest - Ferihegy - BUD", airport_code: "BUD", value: 1059},
            {label: "לונדון, בריטניה - London - All airports - LON", airport_code: "LON", value: 5040},
            {label: "ניו יורק, ארצות הברית - New York - All airports - NYC", airport_code: "NYC", value: 5041},
            {label: "מדריד, ספרד - Madrid - Barajas - MAD", airport_code: "MAD", value: 898},
            {label: "רודוס, יוון - Rhodos - Rhodes Diagoras - RHO", airport_code: "RHO", value: 1048},
            {label: "פראג, צ'כיה - Prague - Ruzyne - PRG", airport_code: "PRG", value: 1119},
            {label: "בנגקוק, תאילנד - Bangkok - All airports - BKK", airport_code: "BKK", value: 21105},
            {label: "בוקרשט, רומניה - Bucharest - All airports - BUH", airport_code: "BUH", value: 21112},
            {label: "בורגס, בולגריה - Bourgas - Burgas - BOJ", airport_code: "BOJ", value: 869},
            {label: "ורנה, בולגריה - Varna - Varna - VAR", airport_code: "VAR", value: 873}
        ],
        origins: [
            {label: "אמסטרדם, הולנד - Amsterdam - Schiphol - AMS", airport_code: "AMS", value: 444},
            {label: "ברלין, גרמניה - Berlin - All airports - BER", airport_code: "BER", value: 21111},
            {label: "פריז, צרפת - Paris - All airports - PAR", airport_code: "PAR", value: 5039},
            {label: "בודפשט, הונגריה - Budapest - Ferihegy - BUD", airport_code: "BUD", value: 1059},
            {label: "לונדון, בריטניה - London - All airports - LON", airport_code: "LON", value: 5040},
            {label: "ניו יורק, ארצות הברית - New York - All airports - NYC", airport_code: "NYC", value: 5041},
            {label: "מדריד, ספרד - Madrid - Barajas - MAD", airport_code: "MAD", value: 898},
            {label: "רודוס, יוון - Rhodos - Rhodes Diagoras - RHO", airport_code: "RHO", value: 1048},
            {label: "פראג, צ'כיה - Prague - Ruzyne - PRG", airport_code: "PRG", value: 1119},
            {label: "בנגקוק, תאילנד - Bangkok - All airports - BKK", airport_code: "BKK", value: 21105},
            {label: "בוקרשט, רומניה - Bucharest - All airports - BUH", airport_code: "BUH", value: 21112},
            {label: "בורגס, בולגריה - Bourgas - Burgas - BOJ", airport_code: "BOJ", value: 869},
            {label: "ורנה, בולגריה - Varna - Varna - VAR", airport_code: "VAR", value: 873}
        ],
        childWithAdultError: 'תינוקות וילדים חייבים בליווי מבוגר או פנסיונר אחד לפחות.',
        babyWithAdultError: 'תינוק מתחת לגיל שנתיים חייב בליווי מבוגר אחד לפחות.',
        maxPassengersError: 'ניתן לבחור עד 9 נוסעים בהזמנה.',
        maxThreeChildError: 'לא ניתן לבחור יותר מ- 3 ילדים בכל חדר',
        destinationsInputPlaceholder: 'הקלידו שם עיר או שדה תעופה',
        packagesInputPlaceholder: "הקלידו שם עיר",
        selectOutboundDate: "בחרו תאריך יציאה",
        selectInboundDate: "בחרו תאריך חזרה",
        datesLocale: 'he-IL',
        destinationsHeader: "חיפוש יעד",
        originHeader: "Departure",
        passengersSelectHeader: "בחרו הרכב נוסעים",
        roomsSelectHeader: "בחרו כמות אורחים לפי חדרים",
        save: 'שמור',
        selectDestinations: 'בחרו יעד',
        selectDeparture: "Departure",
        bestDestinations: 'יעדים מומלצים',
        noDestination: 'היעד שחיפשת יצא לחופשה... בקרוב אצלך!',
        destinationFlightPlaceholder: 'הקלד שם היעד',
        originFlightPlaceholder: "Type origin name",
        adult: 'מבוגרים',
        child: 'ילדים',
        baby: 'תינוקות',
        senior: 'פנסיונרים',
        roundtrip: 'הלוך חזור',
        oneway: 'כיוון אחד',
        originTextTLV: "תל אביב - TLV - ישראל",
        originTextJNB: "יוהנסבורג - JNB - דרום אפריקה",
        landingAt: 'יעד החופשה',
        outboundDate: 'תאריך יציאה',
        inboundDate: 'תאריך חזרה',
        passengersCount: 'הרכב נוסעים',
        directFlightsOnly: 'טיסות ישירות בלבד',
        searchButtonFlights: 'חפשו טיסה',
        searchButtonPackages: 'צאו לחופש',
        childSubText: "(מתחת לגיל 12)",
        babySubText: "(מתחת לגיל שנתיים)",
        seniorSubText: "(מעל גיל 65)",
        headerFlightButton: 'טיסה בלבד',
        headerPackageButton: 'טיסה + מלון',
        room: 'חדר',
        total: 'סה״כ',
        guests: 'אורחים',
        selectChildAgesTitle: " - בחירת גילאי ילדים",
        selectChildAges: "בחרו את גיל הילדים",
        selectChildAge: "בחרו את גיל הילד",
        addRoom: '+ הוספת חדר'
    },
    fr: {
        packages:[
            {
                label:"Amsterdam",
                airport_code:"amsterdam-package",
                value:1
            },
            {
                label:"Berlin",
                airport_code:"berlin-package",
                value:5
            },
            {
                label:"Paris",
                airport_code:"paris-package",
                value:12
            },
            {
                label:"Budapest",
                airport_code:"budapest-package",
                value:2
            },
            {
                label:"Londres",
                airport_code:"london-package",
                value:7
            },
            {
                label:"New York",
                airport_code:"NEW-YORK-package",
                value:9
            },

        ],
        destinations:[
            {
                label:"Amsterdam, Pays-Bas - Amsterdam - Schiphol - AMS",
                airport_code:"AMS",
                value:444
            },
            {
                label:"Berlin, Allemagne - Berlin - All airports - BER",
                airport_code:"BER",
                value:21111
            },
            {
                label:"Paris, France - Paris - All airports - PAR",
                airport_code:"PAR",
                value:5039
            },
            {
                label:"Budapest, Hongrie - Budapest - Ferihegy - BUD",
                airport_code:"BUD",
                value:1059
            },
            {
                label:"Londres, Royaume-Uni - London - All airports - LON",
                airport_code:"LON",
                value:5040
            },
            {
                label:"New York, Etats-Unis - New York - All airports - NYC",
                airport_code:"NYC",
                value:5041
            },
            {
                label:"Madrid, Espagne - Madrid - Barajas - MAD",
                airport_code:"MAD",
                value:898
            },
            {
                label:"Rhodes, Grèce - Rhodos - Rhodes Diagoras - RHO",
                airport_code:"RHO",
                value:1048
            },
            {
                label:"Prague, République Tchèque - Prague - Ruzyne - PRG",
                airport_code:"PRG",
                value:1119
            },
            {
                label:"Bangkok, Thaïlande - Bangkok - All airports - BKK",
                airport_code:"BKK",
                value:21105
            },
            {
                label:"Bucarest, Roumanie - Bucharest - All airports - BUH",
                airport_code:"BUH",
                value:21112
            },
            {
                label:"Bourgas, Bulgarie - Bourgas - Burgas - BOJ",
                airport_code:"BOJ",
                value:869
            },
            {
                label:"Varna, Bulgarie - Varna - Varna - VAR",
                airport_code:"VAR",
                value:873
            }
        ],
        origins:[
            {
                label:"Amsterdam, Pays-Bas - Amsterdam - Schiphol - AMS",
                airport_code:"AMS",
                value:444
            },
            {
                label:"Berlin, Allemagne - Berlin - All airports - BER",
                airport_code:"BER",
                value:21111
            },
            {
                label:"Paris, France - Paris - All airports - PAR",
                airport_code:"PAR",
                value:5039
            },
            {
                label:"Budapest, Hongrie - Budapest - Ferihegy - BUD",
                airport_code:"BUD",
                value:1059
            },
            {
                label:"Londres, Royaume-Uni - London - All airports - LON",
                airport_code:"LON",
                value:5040
            },
            {
                label:"New York, Etats-Unis - New York - All airports - NYC",
                airport_code:"NYC",
                value:5041
            },
            {
                label:"Madrid, Espagne - Madrid - Barajas - MAD",
                airport_code:"MAD",
                value:898
            },
            {
                label:"Rhodes, Grèce - Rhodos - Rhodes Diagoras - RHO",
                airport_code:"RHO",
                value:1048
            },
            {
                label:"Prague, République Tchèque - Prague - Ruzyne - PRG",
                airport_code:"PRG",
                value:1119
            },
            {
                label:"Bangkok, Thaïlande - Bangkok - All airports - BKK",
                airport_code:"BKK",
                value:21105
            },
            {
                label:"Bucarest, Roumanie - Bucharest - All airports - BUH",
                airport_code:"BUH",
                value:21112
            },
            {
                label:"Bourgas, Bulgarie - Bourgas - Burgas - BOJ",
                airport_code:"BOJ",
                value:869
            },
            {
                label:"Varna, Bulgarie - Varna - Varna - VAR",
                airport_code:"VAR",
                value:873
            }
        ],
        childWithAdultError:'תינוקות Les nourrissons et les enfants sont obligés d’être accompagnés par un adulte.',
        babyWithAdultError:'Un nourrisson de moins de 2 ans est obligé d’être accompagné par un adulte au minimum.',
        maxPassengersError:'Il est possible de sélectionner jusqu’à 9 passagers par réservation.',
        maxThreeChildError:'Il n’est pas possible de sélectionner plus de 3 enfants dans une seule chambre.',
        destinationsInputPlaceholder:'Composez le nom de la ville ou de l’aéroport',
        packagesInputPlaceholder:"Composez le nom de la ville",
        selectOutboundDate:"Choisissez une date de départ",
        selectInboundDate:"Choisissez une date de retour",
        datesLocale:'fr-FR',
        destinationsHeader:"Recherchez une destination",
        originHeader: "Departure",
        passengersSelectHeader:"Sélectionnez le nombre de voyageurs",
        roomsSelectHeader:"Choisissez le nombre de voyageurs par chambre",
        save:'Sauver',
        selectDestinations:'Sélectionnez une destination',
        selectDeparture: "Departure",
        bestDestinations:'Meilleures destinations',
        noDestination:'La destination que vous avez sélectionné est partie en vacances… à votre tour!',
        destinationFlightPlaceholder:'Composez le nom de votre destination',
        originFlightPlaceholder: "Type origin name",
        adult:'Adultes',
        child:'Enfants',
        baby:'Bébés',
        senior:'Seniors',
        roundtrip:'Aller-Retour',
        oneway:'Aller simple',
        originTextTLV:"Tel Aviv - TLV – Israel",
        originTextPAR:"Paris - PAR – France",
        originTextJNB: "Johannesburg - JNB - South Africa",
        landingAt:'Arrivée à -',
        outboundDate:'Date de départ',
        inboundDate:'Date de retour',
        passengersCount:'Nombre de passagers',
        directFlightsOnly:'Vols directs uniquement',
        searchButtonFlights:'Rechercher',
        searchButtonPackages:'Partez en vacances',
        childSubText:"(Moins de 12 ans)",
        babySubText:"(Moins de 2 ans)",
        seniorSubText:"(Plus de 65 ans)",
        headerFlightButton:'Vol uniquement',
        headerPackageButton:'Vol + hôtel',
        room:'Chambre',
        total:'Total',
        guests:'Voyageurs',
        selectChildAgesTitle:"Indiquez les âges des enfants",
        selectChildAges:"Indiquez les âges des enfants",
        selectChildAge:"Indiquez l’âge de l’enfant",
        addRoom:'Ajouter une chambre +'
    }
}

export default text;



// WEBPACK FOOTER //
// ./src/locale/text.js